import "core-js/modules/es.number.constructor.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-66a1b813"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "pk-info-wrap"
};
var _hoisted_2 = {
  class: "pk-part"
};
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  class: "pk-name van-ellipsis"
};
var _hoisted_5 = {
  class: "pk-count left-count"
};
var _hoisted_6 = {
  class: "pk-part"
};
var _hoisted_7 = {
  class: "pk-count right-count"
};
var _hoisted_8 = ["src"];
var _hoisted_9 = {
  class: "pk-name van-ellipsis"
};
import { ref, computed, reactive, watch, watchEffect } from 'vue';
import gsap from 'gsap';
import { useStore } from 'vuex';
export default {
  __name: 'pkInfo',
  props: {
    rightCount: {
      type: Number,
      default: 0
    },
    robotCount: {
      type: Number,
      default: 0
    },
    quesData: {
      type: Object,
      default: function _default() {}
    },
    robotFail: {
      type: Boolean,
      default: false
    },
    userFail: {
      type: Boolean,
      default: false
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var store = useStore();
    var robot = computed(function () {
      var _store$getters;
      return (_store$getters = store.getters) === null || _store$getters === void 0 ? void 0 : _store$getters.getRobot;
    });
    var user = computed(function () {
      var _store$getters2;
      return (_store$getters2 = store.getters) === null || _store$getters2 === void 0 ? void 0 : _store$getters2.getUser;
    });
    var tweened = reactive({
      rightScore: 0,
      robotScore: 0
    });
    watchEffect(function () {
      var _props$quesData;
      var scroe = props.rightCount * ((_props$quesData = props.quesData) === null || _props$quesData === void 0 ? void 0 : _props$quesData.score);
      gsap.to(tweened, {
        duration: 0.5,
        rightScore: Number(scroe) || 0
      });
    });
    watchEffect(function () {
      var _props$quesData2;
      var scroe = props.robotCount * ((_props$quesData2 = props.quesData) === null || _props$quesData2 === void 0 ? void 0 : _props$quesData2.score);
      gsap.to(tweened, {
        duration: 0.5,
        robotScore: Number(scroe) || 0
      });
    });
    return function (_ctx, _cache) {
      var _user$value, _user$value2, _robot$value, _robot$value2;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
        class: _normalizeClass(["pk-people", {
          'fail animate__animated animate__shakeX': __props.userFail
        }])
      }, [_createElementVNode("img", {
        class: "pk-avator",
        src: (_user$value = user.value) === null || _user$value === void 0 ? void 0 : _user$value.avatar,
        alt: ""
      }, null, 8, _hoisted_3), _createElementVNode("p", _hoisted_4, _toDisplayString((_user$value2 = user.value) === null || _user$value2 === void 0 ? void 0 : _user$value2.nickname), 1)], 2), _createElementVNode("p", _hoisted_5, _toDisplayString(tweened.rightScore.toFixed(0)), 1)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString(tweened.robotScore.toFixed(0)), 1), _createElementVNode("div", {
        class: _normalizeClass(["pk-people", {
          'fail animate__animated animate__shakeX': __props.robotFail
        }])
      }, [_createElementVNode("img", {
        class: "pk-avator",
        src: (_robot$value = robot.value) === null || _robot$value === void 0 ? void 0 : _robot$value.avatar,
        alt: ""
      }, null, 8, _hoisted_8), _createElementVNode("p", _hoisted_9, _toDisplayString((_robot$value2 = robot.value) === null || _robot$value2 === void 0 ? void 0 : _robot$value2.nickname), 1)], 2)])]);
    };
  }
};